import { render } from "./helm.cattle.io.projecthelmchart.vue?vue&type=template&id=af7b5e80&scoped=true"
import script from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js"
export * from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js"

import "./helm.cattle.io.projecthelmchart.vue?vue&type=style&index=0&id=af7b5e80&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af7b5e80"]])

export default __exports__